import SerpLegacy from './serp_legacy'
import Serp from './serp'

const get = options => {
  if(options.document && options.document.version) {
    if(options.document.version === 1) return new Serp(options) // If it is the last version
    // Add another previous versions here
  } else {
    return new SerpLegacy(options)
  }
}

export default {
  get
}